import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
   clearComments,
   setComments,
   setMailTitle,
   setMessageHistory,
} from "../../../appRedux/actions/FormsV2";
import { getMessageStep, startProcessInstance, runListAction } from "../../../services/api/Api";
import { runListV2Action } from "../../../services/restAPI/ListsV2";
import {
   getEmailDetails,
   getMessageActions,
   getUserWithBoards,
   sendEmailMailboxGmail,
} from "../../../services/restAPI/RestApi";
import { parseMailContent, urlHasJavaRecordId, isDataIdFromJava } from "../../../util/Scripts";
import { setUrlTo } from "../GeneralScripts";
import MessageButtons from "../MessageButtons/MessageButtons";
import FormComplete from "../FormComplete";
import projectConfig from "@projectConfig";
import Comments from "../../Comments/Comments";
import FormError from "../FormError/FormError";
import { Spin } from "../../BP2Components";
import MailContentButtons from "../../MailList/MailContent/MailContentButtons";
import MessageItemHeader from "./MessageItemHeader/MessageItemHeader";
import "./MessageItem.less";
import MailShowContent from "../../MailList/MailShowContent/MailShowContent";
import MessageItemProvider, {
   useMessageItem,
} from "../../../context/MessageItemContext/MessageItemContext";
import { setUserBoards } from "../../../appRedux/actions/Boards";
import { setUserInfo } from "../../../appRedux/actions/User";
import CaseImage from "../CasesList/SingleCase/CaseImage/CaseImage";
import FormV3Controller from "../../Widgets/FormsV3/FormV3Controller";
import { useIntl } from "react-intl";

const MessageItem = ({ instanceId: instanceIdProp, hideComments: hideCommentsProp }) => {
   const isPropsMode = !!instanceIdProp;
   const dispatch = useDispatch();
   const isCommentsWindowMinimized = projectConfig.commentsMinimized;
   const [buttons, setButtons] = useState({ normalButtons: [], systemButtons: {} });
   const [spinActive, setSpinActive] = useState(true);
   const [completeStepError, setCompleteStepError] = useState(false);
   const [isQuestionMode, setIsQuestionMode] = useState(false);
   const [isReadOnly, setIsReadOnly] = useState(false);
   const [emailContentObject, setEmailContentObject] = useState({});
   const [emailSender, setEmailSender] = useState();
   const [emailSubject, setEmailSubject] = useState();
   const [mailId, setMailId] = useState();
   const [mailDetails, setMailDetails] = useState([]);
   const [mail, setMail] = useState([]);
   const { setAnchorTab } = useMessageItem();
   const [currentProcessStep, setCurrentProcessStep] = useState(null);
   const [refreshFormAfterSendingCase, setRefreshFormAfterSendingCase] = useState(false);
   const [commentsWidth, setCommentsWidth] = useState(0);
   const formRef = useRef();
   const [isFormV3, setIsFormV3] = useState(urlHasJavaRecordId(window.location.href));
   const [processConfigId, setProcessConfigId] = useState(null);

   //position: 0 = fullScreen, 1 = small, 2 = hidden
   const [commentsPosition, setCommentsPosition] = useState(
      hideCommentsProp ? 2 : isCommentsWindowMinimized ? 2 : 1,
   );
   const [processStepConfig, setProcessStepConfig] = useState();

   const scrollToFieldByTechname = (techName) => {
      const fieldElement = document.getElementById(`form_${techName}`);
      const parentTab = fieldElement?.closest(".ant-tabs-tabpane");
      if (parentTab) {
         const tabClasses = parentTab.classList;
         tabClasses.forEach((tabClass) => {
            if (tabClass.includes("tab-pane-")) {
               // Find parent element to scroll to so we can see the field + label
               const fieldAndLabelParent =
                  fieldElement.parentElement.parentElement.parentElement.parentElement;
               // If the same tab
               if (parentTab.classList.contains("ant-tabs-tabpane-active")) {
                  fieldAndLabelParent.scrollIntoView();
                  fieldElement.classList.add("anchor-show");
                  // Animate field border
                  setTimeout(() => {
                     fieldElement.classList.remove("anchor-show");
                  }, 1500);
               } else {
                  // Different tab
                  setAnchorTab(tabClass.split("tab-pane-")[1]);
                  // Scroll after animation when we are on different tab
                  setTimeout(() => {
                     fieldAndLabelParent.scrollIntoView();
                     fieldElement.classList.add("anchor-show");
                     // Animate field border
                     setTimeout(() => {
                        fieldElement.classList.remove("anchor-show");
                     }, 1500);
                  }, 1200);
               }
            }
         });
      }
   };

   useEffect(() => {
      const commentsContainer = document.getElementById("case-comments-container");
      setCommentsWidth(commentsContainer?.scrollWidth || 0);
      if (hideCommentsProp || window.innerWidth < 1000) {
         setCommentsPosition(2);
      }
   }, [window.innerWidth]);

   useEffect(() => {
      if (!isPropsMode && currentProcessStep?.instanceId) {
         const url = new URL(window.location.href);
         url.searchParams.set("instanceId", currentProcessStep.instanceId);

         window.history.replaceState(null, "", url.toString());
      }
   }, [currentProcessStep?.stepId]);

   useEffect(() => {
      // All data from url is handled here

      const query = new URLSearchParams(window.location.search);
      const actionIdFromUrl = query.get("actionId");
      const actionKeyBase64 = query.get("actionKey");
      const recordIdFromUrl = query.get("recordId");
      const mailboxIdFromUrl = query.get("mailBoxId");
      const instanceIdFromUrl = instanceIdProp || query.get("instanceId");
      const isEmail = query.get("email");
      const processIdFromUrl = query.get("processId");
      const dataModelName = query.get("dataModelName");
      const dataId = query.get("dataId");
      const actionKey = actionKeyBase64 ? atob(actionKeyBase64) : "";
      // POC process actions
      const listId = query.get("listId");
      const actionV3Name = query.get("v3ActionName");

      if (!isPropsMode && processIdFromUrl) {
         setProcessConfigId(processIdFromUrl);
      }

      if (!isPropsMode && actionIdFromUrl) {
         setMailId(actionIdFromUrl);
      }

      dispatch(clearComments());

      const applyStepData = (step) => {
         setCurrentProcessStep(step);
         setIsQuestionMode(step.isQuestionMode);
         setIsReadOnly(step.configuration.step.readonly);
      };

      let request;

      // If there is an instanceId in the URL, we fetch the formId and other data based on the data returned in the fetched step (getMessageStep).
      // backend manages to return "active" step of the process by instanceId
      if (instanceIdFromUrl) {
         request = getMessageStep(instanceIdFromUrl, "instance").then((res) => {
            const step = res?.data?.step;
            if (!step) return;
            dispatch(setComments(step.comments));
            applyStepData(step);
         });
      } else if (actionV3Name && listId) {
         // TODO - remove getJWT request when java fixes runListV2Action authorization problem
         request = runListV2Action(listId, actionV3Name, recordIdFromUrl).then((res) => {
            if (res?.data?.start?.configuration !== undefined) {
               applyStepData(res.data.start);
            }
         });
      } else if (actionIdFromUrl && (recordIdFromUrl || dataId)) {
         request = runListAction(actionIdFromUrl, recordIdFromUrl || dataId, actionKey).then(
            (res) => {
               if (res?.data?.actions?.configuration !== undefined) {
                  applyStepData(res.data.actions);
               }
            },
         );
      } else if (processIdFromUrl) {
         request = startProcessInstance(processIdFromUrl, dataModelName, dataId).then((res) => {
            let responseData = res.data;
            // TODO - this if can be removed after back fixes their unparseable response
            if (typeof responseData === "string") {
               responseData = JSON.parse(responseData.substring(6));
            }
            if (responseData?.start?.configuration !== undefined) {
               applyStepData(responseData.start);
               setProcessStepConfig(responseData.start.configuration);

               if (responseData?.start?.configuration.refreshOnCloud === "1") {
                  getUserWithBoards().then((res) => {
                     const { boards, ...userData } = res.data;
                     dispatch(setUserInfo(userData));
                     dispatch(setUserBoards(boards));
                  });
               }
            }
         });
      } else if (isEmail) {
         request = getEmailDetails(actionIdFromUrl, mailboxIdFromUrl).then((res) => {
            const mailSender = res?.data?.fromAddresses?.[0];
            const mailSubject = res?.data?.subject;
            const decodedContentElement = parseMailContent(
               res?.data?.textPlain,
               res?.data?.textHtml,
            );

            const mailData = {
               id: res?.data?.messageId,
               mailBody: [
                  {
                     type: decodedContentElement?.type,
                     content: decodedContentElement.content,
                  },
               ],
            };
            setMail(res?.data);
            setMailDetails(mailData);
            setEmailSender(mailSender);
            setEmailSubject(mailSubject);
            setEmailContentObject(decodedContentElement);
         });
      } else if (instanceIdFromUrl) {
         request = getMessageStep(instanceIdFromUrl, "instance").then((message) => {
            const step = message?.data?.step;
            if (!step) return;
            dispatch(setComments(step.comments));
            applyStepData(step);
         });
      } else {
         request = getMessageStep(actionIdFromUrl, "message").then((message) => {
            const step = message?.data?.step;
            if (!step) return;
            dispatch(setComments(step.comments));
            setIsQuestionMode(step.isQuestionMode);
            setIsReadOnly(step.configuration.step.readonly);
            if (message.status === 226) {
               setCompleteStepError(true);
               return;
            }
            setCurrentProcessStep(step);
            if (message.status === 200) {
               getMessageActions(step.instanceId)
                  .then((res) => {
                     dispatch(setMessageHistory(res?.data));
                  })
                  .catch((err) => {
                     console.log(err);
                  });
            }
         });
      }

      request?.finally(() => {
         setSpinActive(false);
      });

      if (!isPropsMode) {
         const url = window.location.href;
         if (url.search("approved") !== -1) {
            sendEmailMailboxGmail(url).then(() => setUrlTo("/cases/new"));
         }
      }
   }, []);

   useEffect(() => {
      if (currentProcessStep?.dataId) {
         setIsFormV3(isDataIdFromJava(currentProcessStep?.dataId));
      }
      if (currentProcessStep?.actions || currentProcessStep?.sysActions) {
         setButtons({
            normalButtons: currentProcessStep?.actions?.filter(
               (element) => element.restrictions?.hidden !== true,
            ),
            systemButtons: currentProcessStep.sysActions,
         });
      }
   }, [currentProcessStep?.stepId]);

   let commentsSizeClass;
   if (commentsPosition == 2) {
      commentsSizeClass = "comments-hidden";
   } else if (commentsPosition == 1) {
      commentsSizeClass = "comments-small";
   } else {
      commentsSizeClass = "comments-full";
   }

   useEffect(() => {
      if (currentProcessStep?.dataId) {
         setIsFormV3(isDataIdFromJava(currentProcessStep?.dataId));
      }
      currentProcessStep && dispatch(setMailTitle(currentProcessStep?.name));
   }, [currentProcessStep?.stepId]);

   // Listen for Nuxt comment-added events and refresh comments
   useEffect(() => {
      const handleNuxtCommentAdded = (event) => {
         const { caseId } = event.detail || {};
         // Check if the comment was added to the currently open case
         if (
            caseId &&
            currentProcessStep?.instanceId &&
            Number(caseId) === Number(currentProcessStep.instanceId)
         ) {
            getMessageStep(currentProcessStep.instanceId, "instance").then((res) => {
               dispatch(setComments(res?.data?.step?.comments));
            });
         }
      };

      window.addEventListener("nuxt:comment-added", handleNuxtCommentAdded);
      return () => window.removeEventListener("nuxt:comment-added", handleNuxtCommentAdded);
   }, [currentProcessStep?.instanceId]);

   const handleCommentsButton = () => {
      setCommentsPosition(commentsPosition - 1);
   };

   return (
      <MessageItemProvider
         formRef={formRef}
         currentProcessStep={currentProcessStep}
         setCurrentProcessStep={setCurrentProcessStep}
      >
         <div
            className={"messages-content-container " + commentsSizeClass}
            style={{
               width: commentsPosition === 2 ? "100%" : `calc(100% - ${commentsWidth}px)`,
            }}
         >
            <div className="messages-content-container__header-fixed">
               <MessageItemHeader
                  currentProcessStep={currentProcessStep}
                  onCommentsButtonClick={handleCommentsButton}
                  commentsPosition={commentsPosition}
               />
               {currentProcessStep?.instanceId && (
                  <CaseImage
                     instanceId={currentProcessStep.instanceId}
                     defaultImageUrl={currentProcessStep.filePath}
                     configId={currentProcessStep.configId}
                     imageShadow={currentProcessStep?.filePath !== null}
                     className="messages-content-container__img"
                  />
               )}
               <MessageButtons
                  buttons={buttons}
                  setCurrentProcessStep={setCurrentProcessStep}
                  sysBtnsConfig={processStepConfig?.overall}
                  currentProcessStep={currentProcessStep}
                  isQuestionMode={isQuestionMode}
                  setRefreshFormAfterSendingCase={setRefreshFormAfterSendingCase}
                  hideChat={hideCommentsProp}
               />
            </div>
            <div className={"messages-content-form-comments " + commentsSizeClass}>
               {emailContentObject?.content ? (
                  <MailShowContent
                     emailSender={emailSender}
                     emailSubject={emailSubject}
                     emailContentObject={emailContentObject}
                  >
                     <MailContentButtons
                        previousMail={mail}
                        mailContent={mailDetails.mailBody[0]}
                     />
                  </MailShowContent>
               ) : currentProcessStep && isFormV3 ? (
                  <FormV3Controller
                     formId={currentProcessStep.formId}
                     dataId={currentProcessStep.dataId}
                     customGUID={currentProcessStep.dataId}
                  />
               ) : currentProcessStep && isFormV3 === false ? (
                  <FormComplete
                     key={`${currentProcessStep.stepId}-${currentProcessStep.formId}-${currentProcessStep.dataId}-${currentProcessStep.instanceId}`}
                     formRef={formRef}
                     isMessageForm={true}
                     formId={currentProcessStep.formId}
                     dataId={currentProcessStep.dataId}
                     instanceId={currentProcessStep?.instanceId}
                     stepId={currentProcessStep.stepId}
                     isReadOnly={isReadOnly}
                     isSubmitVisible={currentProcessStep.configuration?.step?.showSaveForm}
                     initialData={currentProcessStep.initialData}
                  />
               ) : spinActive ? (
                  <Spin className="spin-middle" />
               ) : completeStepError ? (
                  <FormError customError="formComplete.displayStepIsComplete" redirect />
               ) : (
                  <FormError />
               )}
               <Comments
                  buttons={buttons}
                  currentProcessStep={currentProcessStep}
                  isQuestionMode={isQuestionMode}
                  sysBtnsConfig={processStepConfig?.overall}
                  setCommentsPosition={setCommentsPosition}
                  commentsPosition={commentsPosition}
                  commentsSizeClass={commentsSizeClass}
                  scrollToFieldByTechname={scrollToFieldByTechname}
                  setCurrentProcessStep={setCurrentProcessStep}
               />
            </div>
         </div>
      </MessageItemProvider>
   );
};

export default MessageItem;
